<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 msg-return-gender-feminine
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               title-items="Parâmetros"
               link-primary-column="typeGroupSettingName"
               primary-key-column="settingNumber">


        <template #item(field1)="{item}">
          <slot name="field1" :item="item">

            {{ getParamTextByItem(item, 1) }}
            <t-help v-if="item.note !== undefined && item.note !== ''" :title="item.note"/>

          </slot>
        </template>


        <template #actions="{item}">

          <t-list-actions-default
                                  :form-path="module + '/setting/param'" :id="item.settingNumber"
                                  :userAuth="userAuth"/>
        </template>


      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import SettingValidationType from "@/model/types/modules/general/SettingValidationType";
import pageParamMixin from "@/mixins/page/pageParamMixin";

export default {
  mixins: [pageDefaultMixin, pageListMixin, pageParamMixin],
  name: 'Param',
  data() {
    return {
      fields: [
        {key: "typeGroupSettingName", label: "Parâmetro", cols: "3"},
        {key: "typeGroupSettingGrouping", label: "Grupo", cols: "3"},
        {key: 'field1', label: 'Configuração', lineClass: 'table-info'},
        {key: "logControl.updatedDate", label: "Data Modificação", cols: "2", formatter: "datetime"},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    module: {
      type: String,
      required: true,
    },
  },
  methods: {

    mountedPrepare() {

      this.path = this.module + "/setting"

      this.breadcrumb = [
        {text: 'Configurações', to: {name: this.module + '-setting'}},
      ]

    },
    async mountedContinued() {

      this.validationCommentOption = this.getRenderRule('validationSettingParamOption')

      //Seta para link da lista
      this.userAuth.currentPage.path = this.path + "/param"

      //Adiciona acesso a atualização
      if (this.validationCommentOption >= SettingValidationType.type.ONLY_VIEW)
        this.userAuth.validation.validationRead = true

      //Adiciona acesso a atualização
      if (this.validationCommentOption >= SettingValidationType.type.INSERT_OR_UPDATE)
        this.userAuth.validation.validationUpdate = true


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
